
//dependency on dialog.js?
//console.log?

define([], function() {
	
	var myLocation = {
		
		/**
		 * Sets up the country/region/language dropdowns on the header
		 * @return {[void]}
		 */
		init : function() {
			if (COSTCO.util.getLangId() != -1) { //CA specific
				this.initSelectLanguage();
				if($('#regionLangSelEnabledVal').val() != 'BC'){
					this.initSelectRegion();
				}
			}
		},
		
		/**
         * Binds a click event to the anchors inside the langugage select
         * dropdown popover
         * @return {[void]}
         */
		initSelectLanguage : function() {
			$("#language-select-popover-container").on({
				click : function() {
					var selectedLangId = $(this).attr("langid");
                    COSTCO.util.setInSession('navTree', {});
					COSTCO.myLocation.reloadWithNewLanguage(selectedLangId);
				}
			}, 'a');
		},
		
		/**
         * Displays the set province abbreviation on the header region select dropdown popover
         * and binds a click event to the anchors inside the popover
         * @return {[void]}
         */
		initSelectRegion : function() {
			var regionCookieValue = null;
			if (null != COSTCO.util.getRegion()){
				regionCookieValue = escape(COSTCO.util.getRegion());
			}
			var currentCountry = 'CA';
			var currentRegion = 'AB';
			if (regionCookieValue) {
				currentCountry = regionCookieValue.substring(0,2);
				currentRegion = regionCookieValue.substring(2);
			}	
			COSTCO.myLocation.setElementText('#region-select', currentRegion);
			var currentRegionName = COSTCO.myLocation.getStateDisplayName(currentCountry, currentRegion);
			$('#region-select').attr('aria-label',currentRegionName);
			$("#region-select-popover-container").on({
				click : function() {
					regionCookieValue = COSTCO.util.getRegion();
					var selectedRegion = $(this).attr("statecode");
					var newCookieValue = "CA" + selectedRegion;
					if (newCookieValue != regionCookieValue) {
						COSTCO.util.setCookie(cookies.SELECTED_REGION_COOKIE, newCookieValue, cookies.SELECTED_REGION_EXPIRES);						
						if($.cookie(cookies.INV_CHECK_POSTAL_CODE_COOKIE)!= null){
							//$.cookie(cookies.INV_CHECK_POSTAL_CODE_COOKIE, '', $.extend({}, { expires: -1 }));
						}
						if($.cookie(cookies.INV_CHECK_STATE_CODE_COOKIE)!= null){
							$.cookie(cookies.INV_CHECK_STATE_CODE_COOKIE, '', $.extend({}, { expires: -1 }));
						}
						// Initialize cookie to determine grocery delivery 2-day eligible or not 
						COSTCO.myLocation.valid_grocery_region(selectedRegion);
						COSTCO.myLocation.reload_region_change();
					}
				}
			}, 'a');
		},
		
		getStateDisplayName : function(currentCountry, currentRegion) {
			if(typeof(countries) !== 'undefined'){
				var states = countries.find(element => element.code === currentCountry).states;
				var stateName = currentRegion + " " + states.find(e => e.code === currentRegion).displayName + " " + messages.HEADER_REGION_OFFSCREEN_TEXT;
				return stateName;
			} else {
				return "";
			}
		},
		
		/**
         * Displays the language/region select modal if user does not have a province cookie set, otherwise
         * if the function was triggered from the footer(mobile view), displays the modal regardless of the
         * province cookie being set. Displays regional pricing for the province set/selected
         * @param {[boolean]} footerTrigger. Function triggered from footer
         * @return {[void]}
         */
		initLocationModal : function(footerTrigger) {
			
			//loads the language and region select modal with the given province pre-selected
			function loadModal() {
				
				//data to put in the modal popup
				var modalHtml = $('#language-region-modal').html();
				var modalTitle = $(modalHtml).find('.title').text();
				var modalText = $(modalHtml).find('.text');
				
				
				//select the radio button for the current language. Select CA English if button not found
				var langButton = modalText.find('input:radio[name=language][value=' + COSTCO.util.getLangId() + ']');
				if (langButton.length) {
					langButton.prop("checked", true);
				}
				else {
					modalText.find('input:radio[name=language][value=-24]').prop("checked", true);
				}
				
				//hide sections of modal template that aren't needed
				$('.modal-header > button').hide();
				if($("#verify-membership") == null) {
					$('.modal-dialog').attr('id', 'language-region-dialog'); //attach id for styling this modal
				}
				COSTCO.dialog.createExtDialogBox({
					title : modalTitle,
					body : modalText
		        });
				$('.modal-footer').hide();
				$('#language-region-set').on("click", function(){ //hide the modal when user submits. hide.bs.modal triggers another event
					$('#costcoModal').modal('hide');
				});
				
				//hotfix : PRB2002994-Canada Ecommerce iPads Not Loading Language and Region options
				
				//add overlay which will be removed in setProvince method
				//$('#navigation-overlay-div-element').show();
				//$('#costcoModal').css('z-index', '20011');
				$("input[name=region][value='AB']").prop('checked', true);
				
				$('#costcoModal').on({
					'hide.bs.modal' : function() {
						var selectedLang = $('#language-radio-buttons input:radio:checked').val();
						var selectedRegion = $('#region-radio-buttons input:radio:checked').val();
						if (selectedRegion) {
							COSTCO.util.setCookie(cookies.SELECTED_REGION_COOKIE, 'CA' + selectedRegion, cookies.SELECTED_REGION_EXPIRES);
						}
						if($.cookie(cookies.INV_CHECK_POSTAL_CODE_COOKIE)!= null){
							//$.cookie(cookies.INV_CHECK_POSTAL_CODE_COOKIE, '', $.extend({}, { expires: -1 }));
						}
						if($.cookie(cookies.INV_CHECK_STATE_CODE_COOKIE)!= null){
							$.cookie(cookies.INV_CHECK_STATE_CODE_COOKIE, '', $.extend({}, { expires: -1 }));
						}
						COSTCO.myLocation.valid_grocery_region(selectedRegion);// validate the region and sets 'C_2LOC' cookie
						COSTCO.util.addUrlToLangMap(window.location.pathname, selectedLang);
						COSTCO.myLocation.reloadWithNewLanguage(selectedLang); //reload and set lang cookie if user selected different language
					},
					'hidden.bs.modal' : function() {
						//unhide the hidden modal sections
						$('.modal-footer').show();
						$('.modal-header > button').show();
					}
				});
			}
			
			/**
			 * selects region on region modal based on input province,
			 * if no province is provided, Alberta - AB, will be selected
			 */
			function setProvince(province) {
				//default to Alberta if there is no province given
				if (!province) {
					province = 'AB'
					COSTCO.util.setCookie(cookies.SELECTED_REGION_COOKIE, 'CA' + province, cookies.SELECTED_REGION_EXPIRES);
					COSTCO.util.setCookie(cookies.GROCERY_REGION_COOKIE, false, cookies.SELECTED_REGION_EXPIRES);
				}
				
				var modalText = $('#language-region-dialog').find('.text');
				
				//select the radio button for the given province. Select Alberta if button not found
				var regionButton = modalText.find('input:radio[name=region][value=' + province + ']');
				if (regionButton.length) {
					regionButton.prop("checked", true);
					COSTCO.myLocation.setElementText('#region-select', province); //change the region dropdown text too
				}
				else {
					modalText.find('input:radio[name=region][value=AB]').prop("checked", true);
					COSTCO.myLocation.setElementText('#region-select', 'ON');
				}
				//hotfix : PRB2002994-Canada Ecommerce iPads Not Loading Language and Region options
				//remove overlay
				//$('#navigation-overlay-div-element').hide();
				$('#costcoModal').css('z-index', '');
			}
			//ALM#30788-Adding the C_LOC preference in client side as well
			let appProvince =  COSTCO.util.getParamVal(window.location.href,'province');
			if (appProvince) {
				COSTCO.util.setCookie(cookies.SELECTED_REGION_COOKIE, 'CA' + appProvince, cookies.SELECTED_REGION_EXPIRES);
				setProvince(appProvince);
			}
			//ALM#11577- show region modal even if C_2LOC grocery cookie null
			if ($.cookie(cookies.SELECTED_REGION_COOKIE) == null || $.cookie(cookies.SELECTED_REGION_COOKIE).length === 2) {
				loadModal();
				this.geoLocator(setProvince);
			}
			else if(footerTrigger) { 
				loadModal();
				setProvince($.cookie(cookies.SELECTED_REGION_COOKIE).substring(2));
			}
			COSTCO.myLocation.initRegionFees(true);
			if($.cookie(cookies.SELECTED_REGION_COOKIE) != null && $.cookie(cookies.GROCERY_REGION_COOKIE) == null){
				var isRegionAvl  = $.cookie(cookies.SELECTED_REGION_COOKIE).substr(2,3);
				if(isRegionAvl != null){
					COSTCO.myLocation.valid_grocery_region(isRegionAvl);	
				}
			}
		},
		
		/**
         * Attempts to get the user's location and runs a callback function after
         * @param {[function]} callback. The function to execute after getting user's location
         * @return {[void]}
         */
		geoLocator : function(callback) { 
			
			if (!navigator.geolocation) {
				console.log('Geo Location not available');
        		callback(null);
        		return;
        	} 
        	
        	if(typeof(geoLocateToken) == 'undefined'){
        		console.log('BING - Map Token was not defined successfully');
        		callback(null);
        		return;
        	}
        	
        	//the callback function on error for navigator.geolocation.getCurrentPosition()
        	function positionError() {
        		console.log('BING - Error Retrieving Coordinates for Geolocation');
        		callback(null);
        		return;
        	}; 
        	
        	//the callback function on success for navigator.geolocation.getCurrentPosition()
        	function positionCallback(position) {
	        	
	        	COSTCO.myLocation.getStateFromBing(position,
		        	function(data){
		        		console.log('BING - Success retrieving location');
		            	var province = null;
		            	try {
		            		province = data.resourceSets[0].resources[0].address.adminDistrict;
		            	}
		            	catch(err){
		            		console.log('BING - Error with Bing Data');
							callback(null);
		            	}
		            	callback(province);
	        		},
	        		function(){
		        		console.log('BING - Error Retrieving Location Data');
		        		callback(null);
		        	}
	        	);
        	}
        	
        	navigator.geolocation.getCurrentPosition(positionCallback, positionError);
		},
		
		/**
         * Makes AJAX call to a bing service to get user's location.
         * @param {[function]} bingsuccess. The function to execute on success
         * @param {[function]} bingerror. The function to execute on error
         * @return {[void]}
         */
		getStateFromBing: function(position, bingsuccess, bingerror) {
        	var lat = position.coords.latitude;
        	var longitude = -Math.abs(position.coords.longitude);
        	
        	var geocodeRequest = "https://dev.virtualearth.net/REST/v1/Locations/" + lat + "," + longitude + "?o=json&key=" + geoLocateToken;
        	
	        $.ajax({
	            url: geocodeRequest,
	            dataType: 'jsonp',
	            jsonp: 'jsonp',
	            error: function(XMLHttpRequest, textStatus, errorThrown) {
	        		bingerror(XMLHttpRequest, textStatus, errorThrown);
	            },
	            success: function(data, textstatus, XMLHttpRequest) {
	            	bingsuccess(data, textstatus, XMLHttpRequest);
	            }
	        });
	
		},
        
		/**
         * Reloads the page if the given langId is different than the current one
         * @param {[int]} langId
         * @return {[void]}
         */
        reloadWithNewLanguage : function(langId) {
          var appendVariable = null;
          var currentUrl = null;
          var currentLangId = COSTCO.util.getLangId();	
          var url = window.location.href;
          var cookieDomain = wcs.domain;
          if (url.indexOf('bd-cmc.vqa') > -1 || url.indexOf('bd-cmc.vuat') > -1 || url.indexOf('bd-cmc.ecom') > -1) {
            url = COSTCO.myLocation.redirectInManagementCenter(url);
            cookieDomain = '.costco.com';
          }
	    	var langIdFromUrl =  COSTCO.util.getParamVal(url,'langId');
	    	if( Object.keys(COSTCO.util.parseURL(url).params).length === 0){
	    		 appendVariable =  "?";
	    	}else{
	    		 appendVariable =  "&";
	    	}
	    	if (langIdFromUrl == null || langIdFromUrl == undefined || langIdFromUrl == '') {
	    		url += appendVariable + 'langId='+langId;
	    	}else{
	    		var currentLang = "langId=" + langIdFromUrl;
		    	var selectedLangId = "langId=" + langId;
		    	url = url.replace(currentLang, selectedLangId);
	    	}
	    	if(url.toLowerCase().includes('currentpage')) {
	    		url = url.replace('currentPage=' + COSTCO.util.getParamVal(url, 'currentPage') + '&', '');
	    	}
	    	var currentUrl=url;	    	
	    	var paramToStrip='&refine=';			
			COSTCO.util.setCookie(cookies.SELECTED_LANG_COOKIE, langId, cookies.SELECTED_REGION_EXPIRES, cookieDomain);
			if (currentUrl.indexOf(paramToStrip) >= 0){
				currentUrl=currentUrl.split(paramToStrip)[0];
			}
			if(!window.location.hash){
			   window.location.href=currentUrl;
			} else {
			   window.location.reload();
			}	
	    },

        redirectInManagementCenter: function(url) {
          if (url.indexOf('fromIndex=1') >= 0){
            return (window.location.href).replace('?fromIndex=1', 'webapp/wcs/preview/servlet/StoreView');
          } 
          if (window.location.pathname === '/') {
            return window.location.origin + '/webapp/wcs/preview/servlet/StoreView' + '?storeId=' + wcs.storeId;
          }
          if ((/(.*).*product*\.[0-9]+.*html+/i).test(window.location.pathname)) {
            let stringElem = window.location.pathname.split(".")[2];
            return window.location.origin + '/webapp/wcs/preview/servlet/ProductDisplay?partNumber='+ stringElem + '&catalogId=' + wcs.catalogId + '&storeId=' + wcs.storeId;
          }
          if ((/(.*).*html+/i).test(window.location.pathname) && pageType === 'Category') {
            let categoryName = window.location.pathname.split(".")[0].replace('/', '');
            return window.location.origin + '/webapp/wcs/preview/servlet/CategoryDisplay?identifier='+ categoryName + '&catalogId=' + wcs.catalogId + '&storeId=' + wcs.storeId;
          }
          if (window.location.pathname.indexOf('CatalogSearch') >= 0 && pageType === 'Search') {
            let categoryParams = window.location.href.split("/")[1];
            return window.location.origin + '/webapp/wcs/preview/servlet/' + categoryParams + '?storeId=' + wcs.storeId;
          }
          return url;
        },

        reload_region_change: function() {
          if ($('.clear-filter').length > 0) {
          	$('.clear-filter').click();
      		}
	      	else {
	      		window.location.reload();
	      	}
        },
        
        /**
         * Initialize the cookie value to determine whether the selected region is eligible for grocery 2-day delivery or not.
         * @param {[String]} selectedRegion
         * @return {[void]}
         */
        valid_grocery_region: function(selectedRegion) {
        	var isGroceryRegion=false;
            if (groceryEligRgns) {
            	var eligrgn = groceryEligRgns.split(",");
            	for(i = 0; i < eligrgn.length; i++){
            		console.log(eligrgn[i]);
            		if(selectedRegion==eligrgn[i]){
            			isGroceryRegion=true;
            			break;
                     }
            	}
        	}
            COSTCO.util.removeFromSession('isGroceryVisited');
            COSTCO.util.setCookie(cookies.GROCERY_REGION_COOKIE, isGroceryRegion, cookies.SELECTED_REGION_EXPIRES);
          },
        
        //move to Util?
        //gets the element's text node value from the given selector
        getElementText : function(id) {
        	var text = null;
        	if ($(id).length) {
        		text = $(id).get(0).firstChild.nodeValue;
        	}
        	return text;
        },
        
        //move to Util?
        //use this for updating the header on the region selectors when user chooses a region
        setElementText : function(id, text) {
        	if ($(id).length) {
        		$(id).get(0).firstChild.nodeValue = text;
        	}
        },
        
        //pulled from RegionalSelectorMenu_UI.jspf
        saveCatalogSortHeaderDropdownHTML: "",
    	saveNavTreeHTML: "",
        
        initRegionFees : function(saveTags) {
        	
        	function displayCustomTagElments (saveElement, tag, cookieValue) {	
        		//Loop saved Catalog Sort Header Dropdown elements and display	
        		for (var i = 0; i < saveElement.length; i++) {	
        			saveElement[i].remove();
        			
        			if (saveElement[i].attr('data-regionnav')== ""){
        				$(tag).append(saveElement[i]);
        			}
        			else{
        				if (saveElement[i].attr('data-regionnav')== cookieValue){
        					$(tag).append(saveElement[i]);
        				}	
        			}
        		}
        	};
        	
        	function showRegionalFeePrice(location) {	
        		$('*[data-region]').hide();
        		$('[data-price]').hide();
        		$('[data-yourprice]').hide();
        		$('[data-wishlist-linkfee="true"]').hide();
        		var myDiv = $('[data-region ="'+ location + '"]');
        		if (myDiv.length == 0){
        			$('[data-price]').attr('style', 'display: inline !important');
        			$('[data-yourprice]').attr('style', 'display: inline !important');
        			$('[data-wishlist-linkfee="true"]').attr('style', 'display: inline !important');
        		}
        		else{
        			myDiv.attr('style', 'display: inline !important');
        			if ($('#ProductForm .product-option').length == 0 
        				&& $('div',myDiv).hasClass('less-price') == false 
        				&& $('div',myDiv).hasClass('eco-price') == true) {
        				$('.your-price',myDiv).css("border-top","1px solid #333333");
        			}
        			$('[data-wishlist-linkfee="false"]').attr('style', 'display: inline !important');
        		}
        	};
        	
        	function saveCustomTagElements() {	
        		var dropdownHeaderOptionArray = new Array();
        		var dropdownFooterOptionArray = new Array();
        		var navTreeDivArray = new Array();

        		$('#sort_by').find('option[data-regionnav]').each(function(){
        			dropdownHeaderOptionArray.push($(this));
        		});
        		
        		COSTCO.myLocation.saveCatalogSortHeaderDropdownHTML = dropdownHeaderOptionArray;
        	};
        	
        	/**
             * Shows regional price on the search and catalog page
             * @param {[string]} location. The province to show Regional price for
             * @return {[void]}
             */
    	function showRegionalPriceInCatalogSearch() {	
    		var cookieValue = "DEFAULT";
    		var feeRegions = ['CAQC','CANB','CAON','CANS']; //the regions with eco-fees
    		if (feeRegions.indexOf($.cookie(cookies.SELECTED_REGION_COOKIE)) > -1){
    			cookieValue = $.cookie(cookies.SELECTED_REGION_COOKIE);    		
	    		//Display ProductTile currency values
	    		$('.price-parent').each(function() {
	    			var regionDiv = $(this).find('[data-regionnav=' + cookieValue + ']');
	    			if (regionDiv.length > 0 && regionDiv.text()) {
	    				regionDiv.removeClass('hide').show();
	    				$(this).find('[data-regionnav=DEFAULT]').hide();
	    			}
	    		});
    		}

    		//Display Custom Tags for LeftNav and Catalog Sort Dropdowns
    		displayCustomTagElments(COSTCO.myLocation.saveCatalogSortHeaderDropdownHTML,'#sort_by',cookieValue);
    	};
        	
        	/**
             * Shows regional price on the product page
             * @param {[string]} location. The province to show Regional price for
             * @return {[void]}
             */
        	function showRegionalPrice(location) {
        		var parentDiv = $('div.product-tile, div.slick-slide');
        		var defaultSelector = $('[data-regionNav="DEFAULT"]');
        		var regionSelector= $('[data-regionNav="'+location+'"]');
        		parentDiv.each(function(){
        			if($(this).find(regionSelector).length > 0){
        				$(this).find(regionSelector).attr('style', 'display: inline !important');
        				$(this).find(defaultSelector).hide();
        			}
        			else {
        				$('.price-with-linkfee',this).hide();
        				$(this).find(defaultSelector).attr('style', 'display: inline !important');
        			}
        		});
        	};
        	
        	var loc = $.cookie(cookies.SELECTED_REGION_COOKIE);
        	if (saveTags) {
        		saveCustomTagElements();
        	}
        	if (loc != null){
        		if ($('#ProductForm .product-option').length == 0)
        			showRegionalFeePrice(loc);
        		if ($('#search-results').length > 0){
        			showRegionalPriceInCatalogSearch();
           		}
           		else{
            	 	showRegionalPrice(loc);
           		}
        	}
        	
        }
        
       
	} //end region object
	
	// Expose region to the global scope.
    if (typeof window.COSTCO === "undefined") {
        window.COSTCO = new Object();
    } 
	
    window.COSTCO.myLocation = myLocation;
	
	return myLocation;
});



// WEBPACK FOOTER //
// ./js/global/location.js